/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiEmployeeCheckEmailGet$Params {
  value?: string;
  guid?: string;
  'api-version'?: string;
}

export function apiEmployeeCheckEmailGet(http: HttpClient, rootUrl: string, params?: ApiEmployeeCheckEmailGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiEmployeeCheckEmailGet.PATH, 'get');
  if (params) {
    rb.query('value', params.value, {});
    rb.query('guid', params.guid, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiEmployeeCheckEmailGet.PATH = '/api/employee/check-email';
